var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"label":_vm.label,"disabled":_vm.disabled,"rules":_vm.required? [_vm.$v.required(_vm.$t('forms.form.validations.default')), ..._vm.getExtraValidations()]: [..._vm.getExtraValidations()]},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }